import getModalActions from '../../../modals/getModalActions';

import ModalNames from '../modalNames';

export const {
  showAction: showSubmitRequestModal,
  hideAction: hideSubmitRequestModal,
} = getModalActions(ModalNames.SubmitRequest);
